export const COMPANIES_GET_REQUEST = 'COMPANIES_GET_REQUEST';
export const COMPANIES_GET_SUCCESS = 'COMPANIES_GET_SUCCESS';
export const COMPANIES_GET_FAILURE = 'COMPANIES_GET_FAILURE';

export const COMPANIES_GET_BY_ID_REQUEST = 'COMPANIES_GET_BY_ID_REQUEST';
export const COMPANIES_GET_BY_ID_SUCCESS = 'COMPANIES_GET_BY_ID_SUCCESS';
export const COMPANIES_GET_BY_ID_FAILURE = 'COMPANIES_GET_BY_ID_FAILURE';

export const COMPANIES_CREATE_OR_UPDATE_REQUEST = 'COMPANIES_CREATE_OR_UPDATE_REQUEST';
export const COMPANIES_CREATE_OR_UPDATE_SUCCESS = 'COMPANIES_CREATE_OR_UPDATE_SUCCESS';
export const COMPANIES_CREATE_OR_UPDATE_FAILURE = 'COMPANIES_CREATE_OR_UPDATE_FAILURE';

export const COMPANIES_DELETE_REQUEST = 'COMPANIES_DELETE_REQUEST';
export const COMPANIES_DELETE_SUCCESS = 'COMPANIES_DELETE_SUCCESS';
export const COMPANIES_DELETE_FAILURE = 'COMPANIES_DELETE_FAILURE';

export const RESET_COMPANIES_ERRORS = 'RESET_COMPANIES_ERRORS';
